import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../api';

const useReopenGcpCert = (gcpCertID: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      api.gcpCerts.reopenCert({ gcpCertID, action: 'REOPEN' }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['gcpCerts'] });
      queryClient.invalidateQueries({ queryKey: ['gcpCert', gcpCertID] });
    },
  });
};

export default useReopenGcpCert;
